import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { AuthProvider as OidcAuthProvider } from "react-oidc-context"
import { oidcConfig, AUTH_DISABLED } from "@/authConfig"
import { initAnalytics } from "@/analytics"
import { AppWithAuth } from "@/components/auth/app-with-auth"
import { appInsightsService } from "@/services/app-insights"

// Initialize i18n before rendering
import "./i18n"

import "./index.css"
import App from "./App.tsx"

// Initialize Application Insights
appInsightsService.initialize()
initAnalytics()

const rootElement = document.getElementById("root")!

if (AUTH_DISABLED) {
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>
  )
} else {
  createRoot(rootElement).render(
    <StrictMode>
      <OidcAuthProvider {...oidcConfig}>
        <AppWithAuth>
          <App />
        </AppWithAuth>
      </OidcAuthProvider>
    </StrictMode>
  )
}
